@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package com.budgeyet.generated.resources

import kotlin.OptIn
import org.jetbrains.compose.resources.FontResource

private object CommonMainFont0 {
  public val manrope_bold: FontResource by 
      lazy { init_manrope_bold() }

  public val manrope_medium: FontResource by 
      lazy { init_manrope_medium() }

  public val manrope_regular: FontResource by 
      lazy { init_manrope_regular() }

  public val manrope_semibold: FontResource by 
      lazy { init_manrope_semibold() }
}

internal val Res.font.manrope_bold: FontResource
  get() = CommonMainFont0.manrope_bold

private fun init_manrope_bold(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:manrope_bold",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "font/manrope_bold.ttf", -1, -1),
    )
)

internal val Res.font.manrope_medium: FontResource
  get() = CommonMainFont0.manrope_medium

private fun init_manrope_medium(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:manrope_medium",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "font/manrope_medium.ttf", -1, -1),
    )
)

internal val Res.font.manrope_regular: FontResource
  get() = CommonMainFont0.manrope_regular

private fun init_manrope_regular(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:manrope_regular",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "font/manrope_regular.ttf", -1, -1),
    )
)

internal val Res.font.manrope_semibold: FontResource
  get() = CommonMainFont0.manrope_semibold

private fun init_manrope_semibold(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:manrope_semibold",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "font/manrope_semibold.ttf", -1, -1),
    )
)
